import { useQuery } from "@tanstack/react-query";
import { usePermissions } from "@/hooks/use-permissions";
import { hasFeatureAccess, type AccountType } from "@shared/schema";

/** Mirror Mercury's existing legacy Growth gate, including inherited plans.
 * Modular accounts retain their server-enforced billing/entitlement policy. */
export function useMercuryEligibility() {
  const permissions = usePermissions();
  const auth = useQuery<{
    user: { selectedPlan?: AccountType | null; accountKind?: string | null };
    effectivePlan?: AccountType;
  }>({ queryKey: ["/api/app/auth/me"] });
  const loaded = auth.isSuccess && !!auth.data?.user && !permissions.isLoading &&
    (permissions.isOwner || permissions.permissions != null);
  const allowed = loaded && permissions.canView("financials") && (
    auth.data?.user.accountKind != null ||
    hasFeatureAccess(auth.data?.effectivePlan ?? auth.data?.user.selectedPlan ?? "Host", "Growth")
  );
  const failed = auth.isError || (auth.isSuccess && !auth.data?.user) ||
    (!permissions.isLoading && !permissions.isOwner && permissions.permissions == null);
  return { allowed, loaded, failed };
}
